"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownSelectizeInput = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Default component for rendering selected items
 */
var DefaultSelectedItem = function DefaultSelectedItem(_ref) {
  var item = _ref.item,
      onRemove = _ref.onRemove;
  return (0, _preact.h)("div", {
    className: "item",
    "data-value": item
  }, (0, _preact.h)("span", {
    className: "item-name"
  }, item), (0, _preact.h)("a", {
    href: "#",
    className: "remove",
    onClick: function onClick(e) {
      e.preventDefault();
      onRemove();
    },
    title: "Remove"
  }, (0, _preact.h)(_Close.default, {
    width: 12,
    height: 12,
    fill: "currentColor"
  })));
};

var DropdownSelectizeInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownSelectizeInput, _Component);

  var _super = _createSuper(DropdownSelectizeInput);

  function DropdownSelectizeInput() {
    var _this;

    (0, _classCallCheck2.default)(this, DropdownSelectizeInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inputRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchText: '',
      inputInFocus: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectItem", function (item) {
      var _this$props = _this.props,
          allowEmptyValue = _this$props.allowEmptyValue,
          single = _this$props.single;
      if (!item && !allowEmptyValue) return;
      if (!item && allowEmptyValue && item !== '') return;

      if (single !== false) {
        _this.props.onChange(item);

        return;
      }

      if (!_this.isItemSelected(item)) {
        _this.props.onChange(_this.props.selectedItems.concat(item));
      }

      _this.setState({
        searchText: ''
      });
    });
    return _this;
  }

  (0, _createClass2.default)(DropdownSelectizeInput, [{
    key: "onSearchUpdated",
    value: function onSearchUpdated(newSearchText) {
      var _this$props$onSearchC, _this$props2;

      this.setState({
        searchText: newSearchText,
        inputInFocus: true
      });
      (_this$props$onSearchC = (_this$props2 = this.props).onSearchChange) === null || _this$props$onSearchC === void 0 ? void 0 : _this$props$onSearchC.call(_this$props2, newSearchText);
    }
  }, {
    key: "isItemSelected",
    value: function isItemSelected(item) {
      var single = this.props.single;
      return single === false && this.props.selectedItems.some(function (selectedItem) {
        return selectedItem.toLowerCase() === item.toLowerCase();
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this2 = this;

      var _this$props3 = this.props,
          items = _this$props3.items,
          single = _this$props3.single;
      var searchText = this.state.searchText;

      var predicate = function predicate(item) {
        if (single !== false) {
          return true;
        }

        return !_this2.props.selectedItems.find(function (i) {
          return i === item;
        });
      };

      return items.filter(predicate).filter(function (item) {
        return item.toLowerCase().includes(searchText);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var searchText = this.state.searchText;
      if (nextProps.single === false) return;

      if (searchText !== nextProps.selectedItem) {
        this.setState({
          searchText: nextProps.selectedItem
        });
      }
    }
  }, {
    key: "showNewBox",
    value: function showNewBox() {
      var single = this.props.single;
      var searchText = this.state.searchText;

      if (single !== false) {
        return false;
      }

      return searchText !== '';
    }
  }, {
    key: "remove",
    value: function remove(item) {
      var single = this.props.single;
      if (single !== false) return;
      this.props.onChange(this.props.selectedItems.filter(function (i) {
        return i !== item;
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          single = _this$props4.single,
          className = _this$props4.className,
          placeholder = _this$props4.placeholder,
          itemAlias = _this$props4.itemAlias,
          _this$props4$addItemT = _this$props4.addItemTabIndex,
          addItemTabIndex = _this$props4$addItemT === void 0 ? 0 : _this$props4$addItemT,
          _this$props4$itemsTab = _this$props4.itemsTabIndex,
          itemsTabIndex = _this$props4$itemsTab === void 0 ? 0 : _this$props4$itemsTab,
          _this$props4$inputTab = _this$props4.inputTabIndex,
          inputTabIndex = _this$props4$inputTab === void 0 ? 0 : _this$props4$inputTab;
      var _this$props$SelectedI = this.props.SelectedItemComponent,
          SelectedItemComponent = _this$props$SelectedI === void 0 ? DefaultSelectedItem : _this$props$SelectedI;
      var _this$state = this.state,
          inputInFocus = _this$state.inputInFocus,
          searchText = _this$state.searchText;
      var items = this.getItems();
      var showNewBox = this.showNewBox();
      var selectizeClass = single !== false ? 'single' : 'multi';
      var hasItems = single === false && this.props.selectedItems.length;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('selectize-control', className, this.props.class, selectizeClass, 'plugin-remove_button', 'preact-selectize-dropdown')
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('selectize-input', 'items', 'has-options', 'not-full', {
          'selectize-input-active': inputInFocus,
          'has-items': hasItems
        }),
        role: "button",
        tabIndex: inputTabIndex,
        onClick: function onClick() {
          if (_this3.inputRef) {
            _this3.inputRef.focus();
          }
        }
      }, single === false && this.props.selectedItems.map(function (item) {
        var onRemove = function onRemove() {
          return _this3.remove(item);
        };

        return (0, _preact.h)(SelectedItemComponent, {
          key: item,
          item: item,
          onRemove: onRemove
        });
      }), (0, _preact.h)("input", {
        placeholder: hasItems ? '' : placeholder,
        type: "text",
        onFocus: function onFocus() {
          return _this3.setState({
            inputInFocus: true
          });
        },
        onBlur: function onBlur() {
          return setTimeout(function () {
            _this3.setState({
              inputInFocus: false
            });
          }, 100);
        },
        onInput: function onInput(e) {
          if (!(0, _typeGuards.isInputEl)(e.target)) return;

          _this3.onSearchUpdated(e.target.value);
        },
        onChange: function onChange() {
          _this3.selectItem(searchText);
        },
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 9) {
            _this3.selectItem(searchText);

            e.preventDefault();
          }
        },
        value: searchText,
        ref: function ref(_ref2) {
          _this3.inputRef = _ref2;
        }
      })), inputInFocus && (items.length || showNewBox) ? (0, _preact.h)("div", {
        className: (0, _classnames.default)('selectize-dropdown', selectizeClass, this.props.class, 'preact-selectize-dropdown')
      }, (0, _preact.h)("div", {
        className: "selectize-dropdown-content"
      }, showNewBox && searchText.trim() !== '' ? (0, _preact.h)(AddItem, {
        tabIndex: addItemTabIndex,
        selectItem: function selectItem() {
          return _this3.selectItem;
        },
        searchText: searchText,
        isItemSelected: this.isItemSelected(searchText),
        itemAlias: itemAlias
      }) : null, items.map(function (item, index) {
        return (0, _preact.h)("div", {
          role: "button",
          tabIndex: itemsTabIndex,
          key: index,
          className: "option",
          "data-selectable": true,
          "data-value": item,
          onMouseDown: function onMouseDown() {
            return _this3.selectItem(item);
          }
        }, item);
      }))) : null);
    }
  }]);
  return DropdownSelectizeInput;
}(_preact.Component);

exports.DropdownSelectizeInput = DropdownSelectizeInput;

var AddItem = function AddItem(_ref3) {
  var selectItem = _ref3.selectItem,
      searchText = _ref3.searchText,
      isItemSelected = _ref3.isItemSelected,
      itemAlias = _ref3.itemAlias,
      tabIndex = _ref3.tabIndex;

  if (isItemSelected) {
    return (0, _preact.h)("div", {
      className: "existing-item",
      "data-selectable": true
    }, "You have already added this ", itemAlias !== null && itemAlias !== void 0 ? itemAlias : 'item');
  }

  return (0, _preact.h)("div", {
    role: "button",
    tabIndex: tabIndex,
    "data-selectable": true,
    className: "option create-item",
    onMouseDown: function onMouseDown() {
      return selectItem(searchText);
    }
  }, "Add new ", itemAlias !== null && itemAlias !== void 0 ? itemAlias : 'item', " ", (0, _preact.h)("strong", null, "'", searchText, "'"));
};

var _default = DropdownSelectizeInput;
exports.default = _default;